<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
    <div>
        <h3>Site-Wide Notifications</h3>
        <el-button @click="create()" icon="mdi mdi-plus" type="primary"
            >Add Notification</el-button
        >
        <el-table :data="notifications.data" ref="table" row-key="id">
            <el-table-column label="Type" prop="type" width="170">
                <template v-slot="{ row }">
                    {{ getTypeLabel(row.type) }}
                </template>
            </el-table-column>
            <el-table-column label="Message" prop="body">
                <div
                    :title="row.body"
                    class="text-truncate"
                    slot-scope="{ row }"
                >
                    {{ row.body }}
                </div>
            </el-table-column>
            <el-table-column label="Active" prop="is_active" width="120">
                <template v-slot="{ row }">
                    <i
                        :class="{
                            'mdi-check': row.is_active,
                            'mdi-close': !row.is_active,
                        }"
                        class="mdi"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="actions" width="100px">
                <template v-slot="scope">
                    <el-button-group>
                        <el-button
                            @click="editItem(scope.row)"
                            icon="mdi mdi-pencil"
                            size="small"
                            type="text"
                        >
                            Edit
                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <app-pagination
            :pagination="notifications.meta.pagination"
            @current-change="onCurrentPageChange"
            class="mt-10"
        />
        <el-dialog
            :close-on-click-modal="false"
            :title="editing_item ? 'Edit Notification' : 'Create Notification'"
            :visible.sync="dialog_visible"
            width="500px"
        >
            <el-form @submit.prevent="submit()">
                <el-form-item :class="form.state('type')" label="Type" required>
                    <br />
                    <el-radio-group v-model="form.type">
                        <el-radio
                            :key="type.value"
                            :label="type.value"
                            v-for="type in CustomNotificationType"
                        >
                            {{ type.label }}
                        </el-radio>
                    </el-radio-group>
                    <form-feedback :form="form" field="type" />
                </el-form-item>
                <el-form-item
                    :class="form.state('body')"
                    label="Message"
                    required
                >
                    <br />
                    <el-input :rows="3" type="textarea" v-model="form.body">
                    </el-input>
                    <form-feedback :form="form" field="body" />
                </el-form-item>
                <el-form-item :class="form.state('is_active')" label="Active">
                    <el-switch v-model="form.is_active" />
                    <form-feedback :form="form" field="is_active" />
                </el-form-item>
                <el-form-item
                    :class="form.state('is_active')"
                    class="checkbox"
                    label="Visibility"
                    required
                >
                    <br />
                    <el-checkbox
                        @change="onChangeForEveryone"
                        class="block line-height-0"
                        v-model="form.for_everyone"
                    >
                        Everyone (site-wide)
                    </el-checkbox>
                    <el-checkbox
                        :disabled="form.for_everyone"
                        class="block line-height-0"
                        v-model="form.for_independent"
                    >
                        Independent
                    </el-checkbox>
                    <el-checkbox-group
                        :disabled="form.for_everyone"
                        v-model="form.corporations"
                    >
                        <el-checkbox
                            :key="corporation.id"
                            :label="corporation.id"
                            class="block line-height-25"
                            v-for="corporation in corporations"
                        >
                            {{ corporation.name }}
                        </el-checkbox>
                    </el-checkbox-group>
                    <form-feedback :form="form" field="corporations" />
                </el-form-item>
            </el-form>
            <div class="dialog-footer" slot="footer">
                <div class="float-left">
                    <el-button
                        :loading="isItemBusy(editing_item, 'delete')"
                        @click="deleteItem()"
                        icon="mdi mdi-delete"
                        round
                        type="danger"
                    >
                        Delete Notification
                    </el-button>
                </div>
                <div class="float-right">
                    <el-button
                        :disabled="form.busy"
                        @click="dialog_visible = false"
                        >Cancel</el-button
                    >
                    <el-button
                        :loading="form.busy"
                        @click="submit()"
                        icon="mdi mdi-content-save"
                        type="primary"
                    >
                        Save
                    </el-button>
                </div>
                <div class="clearfix"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import CustomNotificationType from "@/constants/custom-notification-types";

export default {
    data() {
        return {
            CustomNotificationType,
            notifications: {
                data: [],
                meta: {
                    pagination: null,
                },
            },
            editing_item: null,
            dialog_visible: false,
            form: new Form({
                type: CustomNotificationType.announcement.value,
                body: null,
                is_active: true,
                for_everyone: false,
                for_independent: false,
                corporations: [],
            }),
        };
    },
    mounted() {
        this.getData({});
    },
    computed: {
        corporations() {
            return this.$store.state.corporations.data;
        },
    },
    methods: {
        getData({ page = 1 }) {
            axios
                .get(`/web-api/custom-notification`, {
                    params: {
                        page,
                    },
                })
                .then((response) => {
                    this.notifications.data = response.data.data;
                    this.notifications.meta.pagination =
                        response.data.meta.pagination;
                });
        },
        getTypeLabel(type) {
            return _.find(CustomNotificationType, (t) => t.value === type)
                .label;
        },
        onCurrentPageChange(page) {
            this.getData({ page });
        },
        create() {
            this.form.clearFields();
            this.editing_item = null;
            this.dialog_visible = true;
        },
        editItem(notification) {
            this.editing_item = notification;
            _.extend(
                this.form,
                _.pick(notification, [
                    "type",
                    "body",
                    "is_active",
                    "for_everyone",
                    "for_independent",
                ]),
            );
            this.form.corporations = notification.corporation_ids;
            this.dialog_visible = true;
        },
        deleteItem() {
            this.$confirm(
                "Are you sure you want to delete notification?",
                "Warning",
                {
                    confirmButtonText: "Delete",
                    confirmButtonClass: "el-button--danger",
                    cancelButtonText: "Cancel",
                    type: "warning",
                },
            )
                .then(() => {
                    this.addBusyItem(this.editing_item, "delete");
                    axios
                        .delete(
                            `/web-api/custom-notification/${this.editing_item.id}`,
                        )
                        .finally(() => {
                            this.removeBusyItem(this.editing_item, "delete");
                        })
                        .then(() => {
                            this.$notify.success({
                                message: "Notification has been deleted.",
                            });
                            this.dialog_visible = false;
                            Utils.arrayDelete(
                                this.notifications.data,
                                this.editing_item,
                            );
                            this.editing_item = null;
                        });
                })
                .catch(() => {
                    // do nothing
                });
        },
        submit() {
            if (this.editing_item) {
                App.put(
                    `/web-api/custom-notification/${this.editing_item.id}`,
                    this.form,
                ).then((response) => {
                    _.extend(this.editing_item, response.data);
                    this.$notify.success({
                        message: "Changes have been saved.",
                    });
                    this.dialog_visible = false;
                });
            } else {
                App.post(`/web-api/custom-notification`, this.form).then(
                    (response) => {
                        this.notifications.data.push(response.data);
                        this.$notify.success({
                            message: "Notification has been created.",
                        });
                        this.dialog_visible = false;
                    },
                );
            }
        },
        onChangeForEveryone(value) {
            this.form.corporations = [];
            this.form.for_independent = false;
        },
    },
};
</script>

<style scoped></style>
